import { Box, SectionHelper, Text, TextButton } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { StatusWarningSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
export const PAGE_AUTO_DOM_ORDER_FIX_OPTION = {
  AUTO: 'auto',
  MANUAL: 'manual'
};
// Radio options for the page-level DOM order rule
export const getPageAutoDomaOrderRadioOptions = (t, handlers) => {
  return [{
    id: PAGE_AUTO_DOM_ORDER_FIX_OPTION.AUTO,
    label: t('accessibility-wizard.rules-list.page-auto-dom-order.radio.auto'),
    optionElement: /*#__PURE__*/React.createElement(Box, {
      padding: "SP3 0"
    }, /*#__PURE__*/React.createElement(SectionHelper, {
      prefixIcon: /*#__PURE__*/React.createElement(StatusWarningSmall, null),
      showPrefixIcon: true,
      size: "small"
    }, /*#__PURE__*/React.createElement(Box, {
      padding: "0 4px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      secondary: true
    }, /*#__PURE__*/React.createElement(Trans, {
      components: {
        text: /*#__PURE__*/React.createElement(Text, {
          size: "tiny",
          weight: "thin",
          secondary: true
        }),
        textButton: /*#__PURE__*/React.createElement(TextButton, {
          ariaLabel: t('accessibility-wizard.rules-list.dom-order.description.learn-more.aria-label'),
          size: "tiny",
          skin: "dark",
          underline: "always",
          weight: "thin",
          onClick: () => {
            handlers.onLearnMoreClick();
            handlers.openArticle();
          }
        })
      },
      i18nKey: "accessibility-wizard.rules-list.page-auto-dom-order.radio.auto.note"
    }))))),
    value: PAGE_AUTO_DOM_ORDER_FIX_OPTION.AUTO
  }, {
    id: PAGE_AUTO_DOM_ORDER_FIX_OPTION.MANUAL,
    label: t('accessibility-wizard.rules-list.page-auto-dom-order.radio.manually'),
    optionElement: /*#__PURE__*/React.createElement(Box, {
      padding: "SP3 0"
    }, /*#__PURE__*/React.createElement(SectionHelper, {
      prefixIcon: /*#__PURE__*/React.createElement(StatusWarningSmall, null),
      showPrefixIcon: true,
      size: "small"
    }, /*#__PURE__*/React.createElement(Box, {
      padding: "0 4px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      secondary: true
    }, t('accessibility-wizard.rules-list.page-auto-dom-order.radio.manually.note'))))),
    value: PAGE_AUTO_DOM_ORDER_FIX_OPTION.MANUAL
  }];
};
//# sourceMappingURL=radio-options.js.map